const spacing = 4;
export default spacing;
//# sourceMappingURL=spacing.js.map